import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@honda-canada/design-system-react';
import React from 'react';
import { specialOfferCards } from './mockSpecialOfferCards.json';
import SpecialOfferCard from './SpecialOfferCard';
const SpecialOffers = ({ fields }) => {
    // TOOD: parse fields to get the special offers
    console.log('SpecialOffers fields', fields);
    const cards = specialOfferCards;
    return (_jsx(Box, { children: cards.map(card => (_jsx(SpecialOfferCard, { ...card, 
            // TODO: disable loyalty offer for now
            hasLoyaltyOffer: false }, `${card.modelInformation.modelYear}-${card.modelInformation.modelName}-${card.modelInformation.trimName}`))) }));
};
export default SpecialOffers;
